import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Container, classNames, Flex, FlexColumn, Media } from "@opensea/ui-kit";
import { getMediaPropsFromMedia } from "../../../../utils";
import { BackgroundOnly } from "../BackgroundOnly";
import { NarrativeMedia } from "../NarrativeMedia";
import { TextOnly } from "../TextOnly";
import { TextWithBackgroundFragment } from "./TextWithBackground.fragment";
export function TextWithBackground(t0) {
  const $ = _c(17);
  const {
    module: moduleKey
  } = t0;
  let moduleData;
  let t1;
  if ($[0] !== moduleKey) {
    moduleData = readFragment(TextWithBackgroundFragment, moduleKey);
    t1 = getMediaPropsFromMedia(moduleData.desktopBackgroundMedia);
    $[0] = moduleKey;
    $[1] = moduleData;
    $[2] = t1;
  } else {
    moduleData = $[1];
    t1 = $[2];
  }
  const desktopMediaProps = t1;
  let t2;
  if ($[3] !== moduleData) {
    t2 = <Media lessThan="lg"><FlexColumn className="w-full"><BackgroundOnly module={moduleData} /><TextOnly module={moduleData} textClassName="size-fit px-4 pb-(--overview-vertical-padding)" /></FlexColumn></Media>;
    $[3] = moduleData;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== desktopMediaProps) {
    t3 = <div className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 z-0 size-full"><NarrativeMedia isBackground={true} media={desktopMediaProps} /></div>;
    $[5] = desktopMediaProps;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute inset-0 z-[1] bg-black/40 content-['']" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames("absolute inset-0 z-[2] flex-1", "py-(--overview-vertical-padding)");
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== moduleData) {
    t6 = <Container className={t5}><TextOnly className="dark h-full" module={moduleData} textContainerClassName="max-w-[var(--max-text-width)]" /></Container>;
    $[9] = moduleData;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <Media greaterThanOrEqual="lg"><Flex className="relative aspect-16/9 size-full max-h-[800px] overflow-hidden">{t3}{t4}{t6}</Flex></Media>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t7) {
    t8 = <>{t2}{t7}</>;
    $[14] = t2;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}